import { render, staticRenderFns } from "./tldetailcont.vue?vue&type=template&id=2db12eb0&scoped=true&"
import script from "./tldetailcont.vue?vue&type=script&lang=js&"
export * from "./tldetailcont.vue?vue&type=script&lang=js&"
import style0 from "./tldetailcont.vue?vue&type=style&index=0&id=2db12eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db12eb0",
  null
  
)

export default component.exports